import Tracked from '~/components/Tracked';

const buttonText = [
  'How to get verified?',
  'How to sell?',
  'How to buy?',
  'What are the fees?'
];

const zendeskUrl = 'https://thesolesupplier.zendesk.com/hc/en-gb';

const SoleMarketFaq = () => {
  return (
    <div className="bg-concrete">
      <div className="mx-auto flex max-w-desktop flex-col gap-2 px-4 py-8 md:px-8 lg:py-16 desktop:px-0">
        <h2 className="text-title-md">FAQs & customer service</h2>
        <p>
          Got any questions or comments about The Sole Supplier Marketplace? Not
          sure where or how to begin? Then make sure you check out the most
          frequently asked questions, including:
        </p>
        <div className="grid grid-cols-2 gap-2 lg:grid-cols-5">
          {buttonText.map((text, index) => (
            <a target="_blank" rel="noreferrer" href={zendeskUrl} key={index}>
              <Tracked.Button
                className="max-md:w-full"
                variant="white-borderless"
                name={`SOLE_MARKET_FAQ_${text.toUpperCase()}`}
                pagePosition="Body"
              >
                {text}
              </Tracked.Button>
            </a>
          ))}
          <a
            target="_blank"
            rel="noreferrer"
            href={zendeskUrl}
            className="col-span-2 lg:col-span-1 lg:pl-4 "
          >
            <Tracked.Button
              className="max-md:w-full"
              variant="forest"
              name="SOLE_MARKET_FAQ_READ_OUR_FAQS"
              pagePosition="Body"
            >
              Read our FAQs
            </Tracked.Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SoleMarketFaq;
